export default "__VITE_ASSET__B9PbCdY7__"